export const FETCH_USER_SUBSCRIPTION_PLANS_START =
  'FETCH_USER_SUBSCRIPTION_PLANS_START';
export const FETCH_USER_SUBSCRIPTION_PLANS_SUCCESS =
  'FETCH_USER_SUBSCRIPTION_PLANS_SUCCESS';
export const FETCH_USER_SUBSCRIPTION_PLANS_FAILURE =
  'FETCH_USER_SUBSCRIPTION_PLANS_FAILURE';

export const CANCEL_USER_SUBSCRIPTION_PLAN_START =
  'CANCEL_USER_SUBSCRIPTION_PLAN_START';
export const CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS =
  'CANCEL_USER_SUBSCRIPTION_PLAN_SUCCESS';
export const CANCEL_USER_SUBSCRIPTION_PLAN_FAILURE =
  'CANCEL_USER_SUBSCRIPTION_PLAN_FAILURE';
